import { render } from "./ErrorPage.vue?vue&type=template&id=5b73ad92&scoped=true"
import script from "./ErrorPage.vue?vue&type=script&lang=js"
export * from "./ErrorPage.vue?vue&type=script&lang=js"

import "./ErrorPage.vue?vue&type=style&index=0&id=5b73ad92&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b73ad92"],['__file',"src/components/ErrorPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b73ad92"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b73ad92', __exports__)) {
    api.reload('5b73ad92', __exports__)
  }
  
  module.hot.accept("./ErrorPage.vue?vue&type=template&id=5b73ad92&scoped=true", () => {
    api.rerender('5b73ad92', render)
  })

}


export default __exports__